import { Line } from "react-chartjs-2";
import "chartjs-adapter-date-fns";
import moment from "moment";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend
);

export const LineChart = ({
  name,
  datasets,
  labels,
  yMin,
  yMax,
  minimumFractionDigits = 2,
}) => {
  const options = {
    type: "line",
    elements: {
      point: {
        radius: 0,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    animation: false,
    aspectRatio: 1,
    showTooltips: true,

    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "rgb(255,255,255)",
        titleColor: "#000000",
        bodyColor: "#000000",
        caretPadding: 100,
        position: "nearest",
        usePointStyle: true,
        borderColor: "rgb(106, 106, 106)",
        borderWidth: 0.5,
        callbacks: {
          title: function (context) {
            const formattedDate = moment(
              context[0].label,
              "MMM DD, YYYY, h:mm:ss a"
            ).format("DD/MM/YY HH:mm:ss");
            return formattedDate;
          },
          label: function (context) {
            if (context.formattedValue.includes(".")) {
            } else {
              const value = parseFloat(
                context.formattedValue.replace(",", ".")
              );
              const formattedValue = isNaN(value)
                ? context.formattedValue
                : value.toFixed(2);

              if (context.dataset.label === "") {
                context.formattedValue = formattedValue;
              } else if (context.formattedValue.length < 7) {
                context.formattedValue = formattedValue;
              }
            }
          },
        },
      },
      legend: {
        position: "top",
        labels: {
          generateLabels: function (chart) {
            const defaultLabels =
              ChartJS.defaults.plugins.legend.labels.generateLabels(chart);

            const updatedLabels = defaultLabels.map((label) => {
              if (label.text === "") {
                label.lineCap = "butt";
                label.fillStyle = "rgba(0, 0, 0, 0)";
                label.lineWidth = 0;
                label.onClick = () => { };
              } else {
                label.padding = 10;
                label.textAlign = "center";
                label.textBaseline = "middle";
              }
              return label;
            });

            return updatedLabels;
          },
        },
      },
      title: {
        display: false,
      },
    },
    hover: {
      mode: "nearest",
      intersect: true,
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "minute",
        },
        grid: {
          offset: false,
        },
        ticks: {
          display: true,
          source: "auto",
          maxRotation: 90,
          minRotation: 90,
          autoSkip: true,
          stepSize: 2,
          callback: (value, index, values) => {
            const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
            return formattedDate;
          },
        },
      },
      y: {
        grid: {
          display: false,
        },
        min: 0,
        max:
          name === "temperature"
            ? 45
            : name === "humidity"
              ? 110
              : name === "co2"
                ? 5000
                : 3,
        ticks: {
          stepSize:
            name === "temperature"
              ? 5
              : name === "humidity"
                ? 10
                : name === "co2"
                  ? 500
                  : 0.5,
          callback: function (value) {
            return value.toLocaleString("pt-BR", { minimumFractionDigits });
          },
        },
      },
    },
  };

  const data = {
    labels: labels,
    datasets: datasets,
  };

  return <Line id={`canvaID${name}`} options={options} data={data} />;
};
